export enum TransactionStatus {
  InProgress = 'InProgress',
  Complete = 'Complete',
  Failed = 'Failed'
}
